import { cronHttp } from "api/cronHttp";
import { http } from "api/http";

const createInvoice = ({ data }) => {
  return http.post("/invoices", data);
};

const updateInvoice = ({ data }) => {
  return http.put(`/invoices/${data?.id}`, data);
};

const getInvoices = ({ queryKey }) => {
  return http.get("/invoices", { params: { ...queryKey[1] } });
};

const getUnbilledTasks = ({ queryKey }) => {
  return http.get("/invoices/unbilled-tasks", { params: { ...queryKey[1] } });
};

const getInvoicesGstPayable = ({ queryKey }) => {
  return http.get("/invoices/gst-payable", { params: { ...queryKey[1] } });
};

const getInvoicesGstTdsReceivable = ({ queryKey }) => {
  return http.get("/invoices/gst-receivable", { params: { ...queryKey[1] } });
};

const getInvoicesForCreditNote = ({ queryKey }) => {
  return http.get("/invoices/credit-note", { params: { ...queryKey[1] } });
};

const getGstPayTotal = ({ queryKey }) => {
  return http.get("/invoices/gst-pay-total", { params: { ...queryKey[1] } });
}

const getGstTdsTotal = ({ queryKey }) => {
  return http.get("/invoices/gst-tds-total", { params: { ...queryKey[1] } });
}

const getAllInvoices = ({ queryKey }) => {
  return http.get("/invoices/all", { params: { ...queryKey[1] } })
}

const exportGstBilling = (data: any) => {
  return cronHttp.post("/invoices/gst-billing-export", data);
}
const exportTdsBilling = (data: any) => {
  return cronHttp.post("/invoices/tds-export", data);
};
const exportGstTdsBilling = (data: any) => {
  return cronHttp.post("/invoices/gst-tds-export", data);
};

const getClientInvoices = ({ queryKey }) => {
  return http.get(`/invoices/${queryKey[1]}`);
};

const getClientBillingInvoices = ({ queryKey }) => {
  return http.get(`/invoices/client-bill`, { params: { ...queryKey[1] } });
}

const getInvoice = ({ queryKey }) => {
  return http.get(`/invoices/${queryKey[1]}`);
};

const getInvoicePreview = ({ queryKey }) => {
  const { invoiceId, orgId } = queryKey[1]
  return http.get(`/invoices/${invoiceId}/preview`, { params: { orgId: orgId } });
};

const downloadInvoice = ({ id, userId, eSign = false }) => {
  return http.post(`/invoices/${id}/download`, { userId: userId, eSign });
};
const downloadInvoicewithoutEmittor = ({ id }) => {
  return http.post(`/invoices/${id}/downloadwithoutemittor`);
};

const cancelInvoice = ({ id }) => {
  return http.post(`/invoices/${id}/cancel`);
};

const submitInvoiceForApproval = ({ id }) => {
  return http.post(`/invoices/${id}/submit-for-approval`);
};

const exportInvoices = ({ data }) => {
  return cronHttp.post(`/invoices/export`, data);
};

const exportUnbilledTasks = (data: any) => {
  return cronHttp.post(`/invoices/unbilled-tasks/export`, data);
};

const getNextInvoiceNumber = ({ queryKey }) => {
  return http.get(`/invoices/generate/next-invoice-number`, {
    params: {
      ...queryKey[1]
    },
  });
};

const getNextInvoicePrefixNumber = ({ queryKey }) => {
  return http.get(`/invoices/generate/next-prefix-invoice-number`, {
    params: {
      ...queryKey[1]
    },
  });
};

const getBillingActivity = ({ queryKey }) => {
  const clientId = queryKey[1].typeId
  return http.get(`/invoices/activity/${clientId}`, { params: { ...queryKey[1] } });
};

const getInvoicingTasks = ({ queryKey }) => {
  return http.get("/invoices/tasks", {
    params: { ...queryKey[1] },
  });
};

const getInvoiceStatusCount = ({ queryKey }) => {
  return http.get("/stats/invoice-status", { params: { ...queryKey[1] } });
};

const getBillingAmounts = ({ queryKey }) => {
  return http.get("/stats/billing-amounts", { params: { ...queryKey[1] } })
};

const getGstPayableAmounts = ({ queryKey }) => {
  return http.get("/stats/gst-payable", { params: { ...queryKey[1] } });
}

const getReceipsAmounts = ({ queryKey }) => {
  return http.get("/stats/receips-amounts", { params: { ...queryKey[1] } })
};
const getInvoiceAmounts = ({ queryKey }) => {
  return http.get("/stats/invoice-amounts", { params: { ...queryKey[1] } })
};

const getOutStandingClients = ({ queryKey }) => {
  return http.get("stats/outstanding-clients", { params: { ...queryKey[1] } })

};

const getInvoicePaymentRecorded = ({ queryKey }) => {
  return http.get(`/invoices/${queryKey[1]}/payment-recorded`);
};

const generateEInvoice = ({ id }) => {
  return http.post(`/invoices/${id}/generate-irn`);
};

const cancelEInvoice = ({ id, data }) => {
  return http.post(`/invoices/${id}/cancel-irn`, data);
};

const updateTdsStatus = (data) => {
  return http.post(`/invoices/update-tds-status`, data);
};

const updateGSTTdsStatus = (data) => {
  return http.post(`/invoices/update-gst-tds-status`, data);
};

export {
  cancelEInvoice,
  generateEInvoice,
  exportGstBilling,
  exportTdsBilling,
  createInvoice,
  updateInvoice,
  getInvoices,
  // getInvoice,
  getInvoicePreview,
  getClientInvoices,
  downloadInvoice,
  cancelInvoice,
  submitInvoiceForApproval,
  exportInvoices,
  getNextInvoiceNumber,
  downloadInvoicewithoutEmittor,
  getClientBillingInvoices,
  getBillingActivity,
  getInvoicingTasks,
  getInvoiceStatusCount,
  getBillingAmounts,
  getReceipsAmounts,
  getInvoiceAmounts,
  getOutStandingClients,
  getGstPayableAmounts,
  getAllInvoices,
  getGstPayTotal,
  getGstTdsTotal,
  exportGstTdsBilling,
  getInvoicePaymentRecorded,
  getInvoicesForCreditNote,
  getInvoicesGstPayable,
  getNextInvoicePrefixNumber,
  updateTdsStatus,
  getInvoicesGstTdsReceivable,
  updateGSTTdsStatus,
  getUnbilledTasks,
  exportUnbilledTasks
};